// see: https://vorg.github.io/pex/docs/pex-physics-springs/spring.html
// todo: mass?
export interface ISpring {
  position: number
  target: number

  velocity: number
  acceleration: number

  stiffness: number
  friction: number
  // threshold: number
}

interface ISpringDef {
  stiffness: number
  friction: number
  // threshold: number
}

export function create() {
  let obj: ISpring = {
    target: 0,
    position: 0,
    velocity: 0,
    acceleration: 0,
    stiffness: 70,
    friction: 3,
    // threshold: 0.04,
  }
  return obj
}

export function createDef(): ISpringDef {
  return {
    stiffness: 70,
    friction: 3,
    // threshold: 0.04,
  }
}

export function defNormal() {
  return {
    stiffness: 70,
    friction: 3,
    // threshold: 0.04,
  }
}

export function defTight() {
  return {
    stiffness: 70,
    friction: 15,
    // threshold: 0.04,
  }
}

export function setDef(obj: ISpring, def: ISpringDef) {
  obj.friction = def.friction
  obj.stiffness = def.stiffness
  // obj.threshold = def.threshold
}

export function update(obj: ISpring, dt: number) {
  let eps = 0.01

  let delta = obj.target - obj.position

  if (
    Math.abs(delta) < eps &&
    Math.abs(obj.velocity) < eps &&
    Math.abs(obj.acceleration) < 0
  ) {
    obj.position = obj.target
    obj.acceleration = 0
    obj.velocity = 0
    return
  }

  obj.acceleration = obj.stiffness * delta - obj.friction * obj.velocity
  obj.velocity += obj.acceleration * dt
  obj.position += obj.velocity * dt
}
